import { Controller } from 'stimulus';
export default class extends Controller {
  async initialize() {
    getAccessToken();
  }
}

export async function getAccessToken() {
  // Make an AJAX call to fetch the access token
  fetch("/get_access_token", {
    method: "GET",
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      "Content-Type": "application/json",
    }
  })
  .then(response => response.json())
  .then(data => {
    localStorage.setItem('access_token', data.access_token);
  })
  .catch(error => console.error("Error fetching access token:", error));
}